export default __webpack_public_path__ + "static/media/Social_Youtube.cd7aa14d.svg";